import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../Services/login.service';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
import { MatDialog } from '@angular/material';
import { LocalService } from 'src/app/Services/local.service';
import { ProposalInformationService } from 'src/app/Modules/medical/modules/broker/modules/buy-policy/services/proposal-information.service';
import { CsrCategoryDialogComponent } from 'src/app/Modules/medical/modules/medical-csr/components/medical-csr-buy-policy/csr-category-dialog/csr-category-dialog.component';
import { QuotationDetails } from 'src/app/Modules/medical/modules/models/quotation-details.model';
import { GlobalService } from 'src/app/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lob-list-csr',
  templateUrl: './lob-list-csr.component.html',
  styleUrls: ['./lob-list-csr.component.css']
})
export class LobListCsrComponent implements OnInit {
  motordesc: any;
  personaldesc: any;
  firedesc: any;
  traveldesc: any;
  medicaldesc: any;

  constructor(public loginservice: LoginService, private quoteService: QuoteService, public dialog: MatDialog, private _local: LocalService, public proposal: ProposalInformationService, private global: GlobalService, private router: Router) { }

  ngOnInit() {

    document.getElementById('generallri').style.visibility = 'visible';
    document.getElementById('generallri').style.display = '';
    document.getElementById('healthlri').style.display = 'none';
    document.getElementById('healthlri').style.visibility = 'hidden';
    document.getElementById('motorlri').style.display = 'none';
    document.getElementById('motorlri').style.visibility = 'visible';
    document.getElementById('propertylri').style.display = 'none';
    document.getElementById('propertylri').style.visibility = 'hidden';
    document.getElementById('travelri').style.display = 'none';
    document.getElementById('travelri').style.visibility = 'hidden';
    this.getProductdescription();
    //to unlock the QQ

    var unlock = sessionStorage.getItem('LOCK');
    if (unlock == "L") {

      var userName = sessionStorage.getItem('userName');
      this.quoteService.unlockQuotedetails(userName).subscribe((data: any) => {
      })
    }
    //END
  }

  openCategoryDialog(): void {
    // this.router.navigate(["/medical/broker/buypolicy"]);
    this.dialog.closeAll();
    this._local.removeString("quoteNumber")
    this.proposal.getCategory().subscribe(success => {
      const dialogRef = this.dialog.open(CsrCategoryDialogComponent, {
        width: '600px',
        data: success["responseBody"]
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result.code == "INDL") {
          this.global.proposal = new QuotationDetails()
          this.global.review = false
          this.router.navigate(["/medical/csr/get_quote/proposal"])
        } else if(result.code == "GRPINDL"){
          this.router.navigate(["/medical/csr/get_quote/gin/proposal"]);
        }else{
          this.router.navigate(["/medical/csr/get_quote/corporate/proposal"]);
        }
          
      })
    })
  }


  getProductdescription() {

    this.loginservice.getProductdescription().subscribe((res: any) => {
      if (res.responseBody != undefined) {
        this.motordesc = res.responseBody.productdesc[0].PC_LONG_DESC;
        this.personaldesc = res.responseBody.productdesc[1].PC_LONG_DESC;
        this.firedesc = res.responseBody.productdesc[2].PC_LONG_DESC;
        this.traveldesc = res.responseBody.productdesc[3].PC_LONG_DESC;
        this.medicaldesc = res.responseBody.productdesc[4].PC_LONG_DESC;
      }
    })
  }

  selectedTab(eve) {

    if (eve == "0") {
      document.getElementById('generallri').style.visibility = 'visible';
      document.getElementById('generallri').style.display = '';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'visible';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';

    } else if (eve == "1") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = '';
      document.getElementById('healthlri').style.visibility = 'visible';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "2") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = '';
      document.getElementById('motorlri').style.visibility = 'visible';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "3") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = '';
      document.getElementById('propertylri').style.visibility = 'visible';
      document.getElementById('travelri').style.display = 'none';
      document.getElementById('travelri').style.visibility = 'hidden';
    } else if (eve == "4") {
      document.getElementById('generallri').style.visibility = 'hidden';
      document.getElementById('generallri').style.display = 'none';
      document.getElementById('healthlri').style.display = 'none';
      document.getElementById('healthlri').style.visibility = 'hidden';
      document.getElementById('motorlri').style.display = 'none';
      document.getElementById('motorlri').style.visibility = 'hidden';
      document.getElementById('propertylri').style.display = 'none';
      document.getElementById('propertylri').style.visibility = 'hidden';
      document.getElementById('travelri').style.display = '';
      document.getElementById('travelri').style.visibility = 'visible';
    }
  }
}
